/* tslint:disable */
/* eslint-disable */
/**
 * Twioku-API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PostLineAccountLinkOneTimePasswordRequest
 */
export interface PostLineAccountLinkOneTimePasswordRequest {
    /**
     * 
     * @type {string}
     * @memberof PostLineAccountLinkOneTimePasswordRequest
     */
    answererId: string;
}

/**
 * Check if a given object implements the PostLineAccountLinkOneTimePasswordRequest interface.
 */
export function instanceOfPostLineAccountLinkOneTimePasswordRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "answererId" in value;

    return isInstance;
}

export function PostLineAccountLinkOneTimePasswordRequestFromJSON(json: any): PostLineAccountLinkOneTimePasswordRequest {
    return PostLineAccountLinkOneTimePasswordRequestFromJSONTyped(json, false);
}

export function PostLineAccountLinkOneTimePasswordRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostLineAccountLinkOneTimePasswordRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'answererId': json['answererId'],
    };
}

export function PostLineAccountLinkOneTimePasswordRequestToJSON(value?: PostLineAccountLinkOneTimePasswordRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'answererId': value.answererId,
    };
}

